import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconSettings } from "@tabler/icons-react";
import { ClientesConfiguracionTiendasDef } from "./ClientesConfiguracionTiendasDef";

export const ClientesConfiguracionTiendasHelpText = '* Aquí puede configurar los productos y servicios de cada tienda.';
export const ClientesConfiguracionTiendasIcon = IconSettings;

export class ClientesConfiguracionTiendas extends Entity<ClientesConfiguracionTiendasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ClientesConfiguracionTiendasDef(), parentKeys);
        this.Form = import('./ClientesConfiguracionTiendasForm').then((module) => module.ClientesConfiguracionTiendasForm);
        this.Title = "Configuración de Tiendas por Cliente";
        this.HelpText = ClientesConfiguracionTiendasHelpText;
        this.Icon = ClientesConfiguracionTiendasIcon;
    }
}